import { FC } from 'react';

import { TaylorMadeDialogContent } from './taylor-made-dialog-content';
import { UpgradeDialogContent } from './upgrade-dialog-content';

export const dialogContentMap: Record<string, FC<{ hasStandardAccess?: boolean }>> = {
  'taylormade-promo': TaylorMadeDialogContent,
  'upgrade-tier': UpgradeDialogContent,
};
